// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import './assets/vue-good-table-theme.css'
import VeeValidate from 'vee-validate';
import VueEditor from 'vue2-editor';
import Notifications from 'vue-notification'
import * as VueGoogleMaps from 'vue2-google-maps';
import {getUserInfo} from '@/http-common.js';
import Vuebar from 'vuebar';
import vSelect from 'vue-select';
import moment from 'moment';
import tz from 'moment-timezone';
import VueFormWizard from 'vue-form-wizard'
import store from './store/store';
import VueAnalytics from 'vue-analytics';
import ToggleButton from 'vue-js-toggle-button';
import VueAffix from 'vue-affix';
import VueChatScroll from 'vue-chat-scroll';
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueCurrencyInput from 'vue-currency-input'
import {DATE_TYPE} from "./enums/dateType";
import Vue2Editor from "vue2-editor";

Vue.use(Vuex);
Vue.use(VueGoodTable);
Vue.use(VeeValidate);
Vue.use(VueEditor);
Vue.use(Notifications);
Vue.use(Vuebar);
Vue.use(Vue2Editor);
Vue.use(VueFormWizard);
Vue.use(ToggleButton);
Vue.use(VueAffix);
Vue.use(VueChatScroll);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: {
      prefix: '$ '
    },
    locale: 'en',
    valueAsInteger: true,
    distractionFree: false
  }
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDJP9P6M4dftWy0bT0wJoe6AOvt3bMFOT0',
    libraries: 'places',
  }
});

const veeValidateLocalization = {
  code: "en",
  custom: {
    'confirm new password': {
      required: 'The Confirm New Password field is required.',
      is: 'The Confirm New Password does not match.'
    },
    'Confirm New Password': {
      required: 'The Confirm New Password field is required.',
      is: 'The Confirm New Password does not match.'
    }
  },
  messages: {
    min: (field, [length]) => `The ${field} field must be at least ${length} characters.`
  }
};

VeeValidate.Validator.localize('en', veeValidateLocalization);

VeeValidate.Validator.extend('password', {
  getMessage: field => 'Passwords must not contain your display name (First or Last Name), must be at least 6 characters and contain one digit, one lower case, one upper case, and one special character !@#$%^&*()',
  validate: value => {
    return new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()])[.*a-zA-Z0-9!@#$%^&*()]{6,16}$').test(value);
  }
});

VeeValidate.Validator.extend('currency', {
  getMessage: field => 'The field is required.',
  validate: value => {
    return (value != '$ 0.00' && value != '');
  }
});

VeeValidate.Validator.extend('emails_arr', {
  getMessage: field => 'All emails must be valid.',
  validate: value => {
    let valid = true;
    value.forEach(item => {
      let test = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$').test(item.toLowerCase());
      if (!test) {
        valid = false;
      }
    });
    return valid;
  }
});

VeeValidate.Validator.extend('accounts_arr', {
  getMessage: field => 'Please select at least one account.',
  validate: value => {
    return (value && value.length > 0);
  }
});

Vue.component('v-select', vSelect);

Vue.filter('formatDateForMessage', date => {
  const local = moment(date, `${DATE_TYPE.BACKEND} hh:mm A`);
  return local.format(getUserInfo('date_format') + ' hh:mm A');
});

Vue.filter('formatDate', date => {
  const local = moment.tz(date, 'Etc/GMT-0');
  return local.clone().tz(getUserInfo('time_zone')).format(getUserInfo('date_format') + ' hh:mm A');
});

Vue.filter('formatDateOnlyTime', date => {
  const local = moment.tz(date, 'Etc/GMT-0');
  return local.clone().tz(getUserInfo('time_zone')).format('hh:mm A');
});

Vue.filter('formatDateByArrival', date => {
  const local = moment.tz(date, 'Etc/GMT-0');
  let timeZone = getUserInfo('time_zone');
  const dateTz = local.clone().tz(timeZone);
  // check date of arrival
  if (dateTz.isSame(new Date(), "day")) {
    return dateTz.format('hh:mm A');
  }
  return local.clone().tz(timeZone).format(getUserInfo('date_format'));
});

Vue.filter('formatDateModal', date => {
  if (date) {
    const local = moment.tz(date, 'Etc/GMT-0');
    return local.clone().tz(getUserInfo('time_zone')).format(getUserInfo('date_format'));
  }
});

Vue.filter('formatDateModalNoTimeZone', date => {
  if (date) {
    return moment(date).format(getUserInfo('date_format'));
  }
});

Vue.filter('formatByTimezone', date => {
  if (date) {
    const local = moment.tz(date, 'Etc/GMT-0');
    return local.clone().tz(getUserInfo('time_zone')).format(getUserInfo('date_format'));
  }
});

Vue.filter('striphtml', function (value) {
  return value && value.replace(/(<([^>]+)>)/ig, "");
});

Vue.filter('anonymizeEmail', function (email) {
  if (!email) return ''

  const emailSplitted = email.split('@');
  if (emailSplitted[0].length > 3) {
    emailSplitted[0] = `${emailSplitted[0].slice(0, 3) + '*'.repeat((emailSplitted[0].length - 3))}`
  }

  return emailSplitted.join('@')
})

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-110381199-2'
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js